/**
 * In-memory list-text transfer between routes.
 *
 * The text-entry counterpart to pending-file.ts: TextToOrderDialog stashes the
 * text the user typed and navigates to /list, which consumes it on mount.
 * Single-shot, and works because wouter does client-side routing — the JS
 * module stays alive across route changes.
 */

let pendingListText: string | null = null;

export function setPendingListText(text: string) {
  pendingListText = text;
}

export function consumePendingListText(): string | null {
  const text = pendingListText;
  pendingListText = null;
  return text;
}
